import React, { useCallback, useState } from "react";
import { Modal, Select, Space, Spin } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import { makeStyles } from "@material-ui/core/styles";
import NGITextArea from "components/Common/inputs/NGITextArea";
import NGISelect from "components/Common/inputs/NGISelect";
const { Option } = Select;

const useStyles = makeStyles({
  root: {
    width: "400px!important",

    "& .ant-modal-header": {
      padding: "24px 24px 0 !important",
    },

    "& .ant-modal-body": {
      padding: "10px 24px !important",
    },
  },
  description: {
    whiteSpace: "pre-wrap",
    padding: "0 10px",
  },
  comment: {
    marginBottom: 15,
  },
  reasonContainer: {
    marginBottom: 15,
  },
});

const ConfirmationModal = ({
  onConfirm,
  onCancel,
  hideCancel = false,
  title = "Confirmation",
  description = "Are you sure?",
  cancelBtnTitle = "No",
  confirmBtnTitle = "Yes",
  withComment = false,
  isCommentRequired = false,
  loading = false,
  commentLength,
  reasons = [],
  reasonTitle = "Reason",
  commentTitle = "",
  isReasonRequired = false,
}) => {
  const classes = useStyles();
  const [comment, setComment] = useState("");
  const [reason, setReason] = useState("");

  const onCommentChange = useCallback(e => setComment(e.target.value), []);

  const handleConfirm = useCallback(() => {
    onConfirm(comment, reason);
    onCancel();
  }, [comment, reason]);

  return (
    <Modal className={classes.root} open={true} closable={false} title={title} onCancel={onCancel} footer={[]}>
      <Spin spinning={loading}>
        <p className={classes.description}>{description}</p>
        {!!reasons.length && (
          <div className={classes.reasonContainer}>
            <b>{reasonTitle}</b>
            <NGISelect allowClear fullWidth onChange={setReason} showSearch placeholder="Select value">
              {reasons?.map(item => (
                <Option key={item} value={item}>
                  {item}
                </Option>
              ))}
            </NGISelect>
          </div>
        )}
        {withComment && (
          <>
            {commentTitle && <b>{commentTitle}</b>}
            <NGITextArea
              className={classes.comment}
              rows={5}
              maxlength={commentLength}
              placeholder="Please add your reason"
              onChange={onCommentChange}
            />
          </>
        )}
        <Space>
          {!hideCancel && (
            <CustomButton onClick={onCancel} size="small" type="primary" color="outlined" text={cancelBtnTitle} />
          )}
          <CustomButton
            disabled={(isCommentRequired && !comment) || (isReasonRequired && !reason)}
            onClick={handleConfirm}
            size="small"
            type="primary"
            text={confirmBtnTitle}
          />
        </Space>
      </Spin>
    </Modal>
  );
};

export default ConfirmationModal;
